import React from "react";

import { ReactComponent as TwitterIcon } from "../../../img/twitter.svg";
import { ReactComponent as DiscordIcon } from "../../../img/discord.svg";

export const SectionF: React.FC = () => {
  return (
    <section className="sectionf" id="sectionf">
      <div className="row gx-panels">
        <div className="col-lg-6 col-12 d-flex align-items-stretch justify-content-end">
          <div className="black-panel float-end">
            <p className="panel-title display-4">Join our growing community</p>
            <p className="panel-description fs-5">
              Find support, chat with members of the Bebop team, and connect with other DeFi pros
              and newbies.
            </p>
            <div className="d-flex justify-content-center" style={{ flex: 1 }} />
            <a href="https://discord.com/invite/bebop" target="_blank" rel="noreferrer">
              <button type="button" className="btn-discord mt-3 mt-sm-0 btn-lg">
                <DiscordIcon className="me-2" /> Join our Discord
              </button>
            </a>
          </div>
        </div>
        <div className="col-lg-6 col-12 d-flex align-items-stretch justify-content-start">
          <div className="black-panel">
            <p className="panel-title display-4">Stay up-to-date with the latest news</p>
            <p className="panel-description fs-5">
              Never miss a feature, update, or news. Stay connected as we build a better world in
              DeFi.
            </p>
            <div className="d-flex" style={{ flex: 1 }} />
            <a href="https://twitter.com/bebop_dex" target="_blank" rel="noreferrer">
              <button type="button" className="btn-twitter me-0 me-sm-3 btn-lg">
                <TwitterIcon className="me-2" /> Follow on Twitter
              </button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
